import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import { getApiConnectionFirms, getApiConnections, getFirms } from './common';

const getApiConnectionId = (_state: AdminState | ClientState, _firmId: string, apiConnectionId: string) => apiConnectionId;

export const getApiConnectionFirmsArray = createSelector(getApiConnectionFirms, (apiConnectionFirms) => {
    return Object.keys(apiConnectionFirms)
        .map(id => apiConnectionFirms[id])
        .filter(apiFirm => !apiFirm.IsDeleted);
});

export const getAPIConnectionFirmsFromConnectionID = createSelector(
    [ getFirms, getApiConnections, getApiConnectionFirmsArray, getApiConnectionId ],
    (firms, apiConnections, apiConnectionFirmsArray, apiConnectionId) => {
        if (!apiConnectionId) return [];

        const apiConnectionFirms = apiConnectionFirmsArray
            .filter(connection => connection.APIConnectionId == apiConnectionId && !connection.IsDeleted);
        const connectionFirms = apiConnectionFirms
            .map((apiConnection) => {
                return {
                    apiConnection: apiConnections[apiConnectionId],
                    apiFirm: apiConnection,
                    firm: firms[apiConnection.FirmId]
                };
            })
            .filter((mappedApiConnectionFirm) => mappedApiConnectionFirm.firm &&
                !mappedApiConnectionFirm.firm.IsDeleted &&
                !mappedApiConnectionFirm.firm.IsClosed);

        return connectionFirms;
    }
);